module.exports = __webpack_public_path__ + "static/media/virus.4377faab.svg";